<template>
  <div>
    <p class="cm-mg-p-wzd text-center text-muted">
      {{ $t('vie.Pag.Das.Bus.ste.FifthStep.text1') }}
    </p>
    <hr />
    <div class="row">
      <div class="col-12">
        <div class="form-group">
          <label>{{ $t('common_words.modules') }}</label>
          <br />
          <el-select
            collapse-tags
            @change="selectAllFromSelect('model.modules_ids', modules)"
            clearable
            filterable
            multiple
            class="select-primary custom-width-select shadow-sm"
            v-model="model.modules_ids"
            size="large"
            :placeholder="`${$t('common_words.select')}... `"
          >
            <el-option
              v-for="option in modules"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.id + ' - ' + option.name"
              :key="option.id + ' - ' + option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import MixinPermissions from 'src/util/mixinPermissions';
import mixinMasters from 'src/util/mixinMasters';
import SweetAlert from 'src/class/Alerts';
import { Axios } from 'src/class/Axios.js';

export default {
  data() {
    return {
      model: {
        modules_names: [],
        modules_ids: [],
      },
      modules: null,
    };
  },
  mixins: [MixinPermissions, mixinMasters],
  watch: {
    '$i18n.locale': 'getSelectAll',
  },
  methods: {
    getSelectAll() {
      this.modules = this.concatAll(this.modules.splice(1));
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },

    validate() {
      return this.$validator.validateAll().then((res) => {
        this.$emit('on-validated', res, this.model);

        let others = [];
        this.model.modules_ids.forEach((element) => {
          this.modules.forEach((item) => {
            if (element == item.id) {
              others.push(item.name);
            }
          });
        });

        this.$emit('fillBusinessForm', 'fifthStep', { modules_names: others });
        return res;
      });
    },
  },

  created() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);

      Axios.getMasters('modules/indexfield')
        .then((response) => {
          this.modules = this.concatAll(response.data.data);

          if (!sessionStorage.getItem('editForm') && this.modules.length == 1)
            this.model.modules_ids.push(this.modules[0].id);

          this.showHideLoading();
        })
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.warning(error.response.data.message);
        });
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    let editForm = {};
    if (this.isUpdate() && sessionStorage.getItem('editForm')) {
      editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model.modules_ids = editForm.modules_ids;
    }
  },
};
</script>
<style></style>
